import { connect } from 'react-redux';
import StorageMartLanguageMenu from 'components/StorageMartLanguageMenu';
import { getAvailableLanguages } from 'store/modules/page';

const mapStateToProps = state => ({
  languages: getAvailableLanguages(state),
});

const mapDispatchToProps = null;

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(StorageMartLanguageMenu);
